<template>
  <div class="bindAccount_box">

    <div class="bind_account ipad_form">
      <p>
        {{$t('bindAccountText.text5')}}
      </p>
      <p> {{$t('verifyText.title1')}}：{{email}}</p>
      <ul class="form_list">
        <div id="captcha"></div>
        <li class="form_item">
          <!-- <p class="title">{{$t('toast.verifyTitle')}}</p> -->
          <div class="form_input psw_input">
            <input type="text"
                   v-model="verify_code"
                   :placeholder="$t('toast.verifyTitle')"
                   class="psw">
            <button class="psw_btn"
                    :disabled="showIndex"
                    :class="{ disabled: showIndex }"
                    @click="clickVerifyCode">{{btnValue}}</button>
          </div>
        </li>

        <li class="form_item "
            :class="noclickFlag?'form_submit':'form_no_submit'"
            ref="form_submit"
            @click="userUp()">
          {{$t('toast.comfirmBtn1')}}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mailMosk } from '@/utils/utils'
import { appPostMessage } from '@/utils/communication'
import initNECaptchaWithFallback from '@/assets/js/yidun-captcha'
import { sendVerifyCode } from '@/api/login'
import { userUpgrade } from '@/api/hw'
import { setSessionStorage, getSessionStorage } from '@/utils/stage'
export default {
  data() {
    return {
      email: '',
      selectFlag: 1,
      terminal: '',
      scene_id: 3,
      password: '',
      showIndex: false,
      seeFlag: false,
      bindAccountInfo: '',
      verify_code: '',
      btnValue: this.$t('toast.verifycodeBtn'),
      img1: require('../../assets/images/visible_icon.png'),
      img2: require('../../assets/images/invisible_icon.png'),
      noclickFlag: false,
      loginFlag: false,
    }
  },
  watch: {
    verify_code(newVal) {
      if (newVal) {
        this.noclickFlag = true
      } else {
        this.noclickFlag = false
      }
    },
  },
  created() {
    this.init()
  },
  mounted() {
    this.NECaptchaInit()
  },
  methods: {
    init() {
      this.configData = JSON.parse(getSessionStorage('message'))
      this.userInfo = JSON.parse(getSessionStorage('accountStorage'))
      this.bindAccountInfo = JSON.parse(getSessionStorage('bindAccountInfo'))
      this.email = mailMosk(this.bindAccountInfo.phone)
      this.terminal = this.bindAccountInfo.phone
      this.getWm()
    },
    NECaptchaInit() {
      const captchaId = this.$store.getters.captcha_id
      var that = this
      var neWidth = 320 + 'px'
      initNECaptchaWithFallback(
        {
          // config对象，参数配置
          captchaId: captchaId, // 从易盾申请的验证码id
          element: '#captcha', // 容器元素/容易元素选择器
          mode: 'bind', // 验证码模式
          width: neWidth, // 验证按钮宽度，推荐260px-400px
          defaultFallback: false,
          onVerify: function (err, data) {
            if (data) {
              that.sendVerifyCode(data.validate)
              that.NECaptchaInit()
            }
          },
        },
        function onload(instance) {
          // 初始化成功后得到验证实例instance，可以调用实例的方法。
          that.NECaptcha = instance
          that.ydErr = true
        },
        function onerror(err) {
          that.ydErr = false
          // console.log(66666)
          // 初始化失败后触发该函数，err对象描述当前错误信息
          console.log(err)
        }
      )
    },
    clickVerifyCode() {
      //   if (this.terminal) {
      if (this.ydErr) {
        this.NECaptcha && this.NECaptcha.verify()
      } else {
        this.sendVerifyCode()
        return
        // }
      }
    },

    sendVerifyCode(valid) {
      let validateData = ''
      if (typeof valid === 'string') {
        validateData = valid
      }
      if (!this.codeFlag) {
        this.codeFlag = true
        const data = {
          terminal: this.terminal,
          scene_id: 11,
          validate: validateData,
        }
        const msg = Object.assign(
          JSON.parse(JSON.stringify(this.configData)),
          data
        )
        sendVerifyCode(msg).then((res) => {
          this.getCode()
          if (res.errcode === 503) {
            if (this.ydErr) {
              this.NECaptcha && this.NECaptcha.verify()
            } else {
              this.sendVerifyCode()
            }
          } else if (res.errcode === 0) {
            this.$toast(res.errmsg)
          }
        })
      }
      setTimeout(() => {
        this.codeFlag = false
      }, 1000)
    },
    getWm() {
      const _this = this
      if (window.wm) {
        window.wm &&
          window.wm.getToken(
            this.$store.getters.yd_product_id,
            function (token) {
              _this.token = token
            },
            function (error) {
              // 错误处理
              _this.token = ''
            }
          )
      }
    },
    getCode() {
      this.showIndex = true
      let show = true
      let count = ''
      let timer = null
      const TIME_COUNT = 60
      if (!timer) {
        count = TIME_COUNT
        show = false
        timer = setInterval(() => {
          if (count > 0 && count <= TIME_COUNT) {
            count--
          } else {
            show = true
            clearInterval(timer)
            timer = null
          }
          if (count === 0) {
            this.btnValue = this.$t('toast.verifycodeBtn2')
            this.showIndex = false
            return
          } else {
            this.btnValue = count + 's'
          }
        }, 1000)
      }
    },
    userUp() {
      if (this.loginFlag) {
        return
      }
      this.loginFlag = true
      setTimeout(() => {
        this.loginFlag = false
      }, 2000)
      const access_token = JSON.parse(
        getSessionStorage('accountStorage')
      ).access_token
      const data = {
        terminal: this.terminal,
        verify_code: this.verify_code,
        access_token: access_token,
      }
      const msg = Object.assign(
        JSON.parse(JSON.stringify(this.configData)),
        data
      )
      userUpgrade(msg).then((res) => {
        console.log(this.userInfo, res.data.user_entity)
        const user_entity = res.data.user_entity
        this.userInfo['email'] = user_entity.email
        this.userInfo['username'] = user_entity.username
        this.userInfo['access_token'] = user_entity.access_token
        setSessionStorage('accountStorage', JSON.stringify(this.userInfo))
        this.$router.push({ path: '/success', query: { id: 7 } })
        if (this.userInfo.login_type == 96) {
          const appmsg = { code: 14, data: user_entity }
          appPostMessage(appmsg)
          return
        }
        const appmsg = { code: 15, data: user_entity }
        appPostMessage(appmsg)
      })
    },
  },
}
</script>

<style scoped lang="less">
.bindAccount_box {
  padding: 0 30/75rem;
  padding-top: 40/75rem;
  box-sizing: border-box;
  .select_btn {
    width: 380/75rem;
    height: 53/75rem;
    background: #f2f3f4;
    border-radius: 27/75rem;
    line-height: 53/75rem;
    // margin-top: 40/75rem;
    span {
      display: inline-block;
      width: 50%;
      text-align: center;
      color: #959595;
      font-size: 26/75rem;
    }
    .select_active {
      border-radius: 27/75rem;
      background: #ff7391;
      color: #fff;
    }
  }
  .form_list {
    width: 610/75rem;
    margin: 0 auto;
  }
  .form_item {
    margin-top: 30/75rem;
    .title {
      font-size: 26/75rem;
      font-family: 'Microsoft YaHei';
      line-height: 48/75rem;
      color: #000000;
      text-align: left;
    }
    .form_input {
      width: 610/75rem;
      height: 79/75rem;
      border: 1px solid #575757;
      opacity: 1;
      border-radius: 6/75rem;
      padding-left: 30/75rem;
      padding-top: 21/75rem;
      box-sizing: border-box;
      position: relative;
      //   margin: 0 auto;
      .phone {
        border: none;
        outline: none;
        width: 100%;
        height: 34/75rem;
      }
      .psw {
        border: none;
        outline: none;
        width: 470/75rem;
        width: 100%;
        // height: 34/75rem;
        // background: #000;
        // border-right: 1px solid #cfcfcf;
      }
      .visible_icon {
        display: inline-block;
        width: 35/75rem;
        height: 35/75rem;
        position: absolute;
        top: 22/75rem;
        right: 30/75rem;
        //   float: right;
        //   margin-top: ;
      }
    }
    .psw_input {
      padding-right: 180/75rem;
      box-sizing: border-box;
      position: relative;
      .psw_btn {
        background: none;
        border: none;
        outline: none;
        position: absolute;
        display: inline-block;
        width: 180/75rem;
        right: 0;
        top: 0;
        height: 76/75rem;
        line-height: 76/75rem;
        letter-spacing: 5/75rem;
        &:before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          width: 1px;
          height: 45/75rem;
          background: #cfcfcf;
          transform: translateY(-50%);
        }
      }
    }
  }
}
</style>